const SCROLL_HIDE_THRESHOLD_PX = 50;

class LoverseTrustpilotBanner extends HTMLElement {
  #lastScroll = 0;
  #ticking = false;
  #onScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      const current = window.pageYOffset;
      if (current > this.#lastScroll && current > SCROLL_HIDE_THRESHOLD_PX) {
        this.classList.add('tp-hidden');
      } else {
        this.classList.remove('tp-hidden');
      }
      this.#lastScroll = current;
      this.#ticking = false;
    });
  };

  connectedCallback() {
    // The section's "Hide while scrolling down" setting; off = no scroll listener, no animation.
    if (this.dataset.hideOnScroll === 'false') return;
    window.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
  }
}

if (!customElements.get('loverse-trustpilot-banner')) {
  customElements.define('loverse-trustpilot-banner', LoverseTrustpilotBanner);
}
